"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddToGroupPosition = exports.UserPreferenceEventActions = exports.EventTypes = void 0;
var EventTypes;
(function (EventTypes) {
    EventTypes["UserPreferenceEvent"] = "UserPreferenceEvent";
})(EventTypes = exports.EventTypes || (exports.EventTypes = {}));
var UserPreferenceEventActions;
(function (UserPreferenceEventActions) {
    UserPreferenceEventActions["UserPreferenceCreated"] = "UserPreferenceCreated";
    UserPreferenceEventActions["UserPreferenceUpdated"] = "UserPreferenceUpdated";
    UserPreferenceEventActions["UserPreferenceDeleted"] = "UserPreferenceDeleted";
    UserPreferenceEventActions["CreateUserPreference"] = "CreateUserPreference";
    UserPreferenceEventActions["UpdateUserPreference"] = "UpdateUserPreference";
    UserPreferenceEventActions["DeleteUserPreference"] = "DeleteUserPreference";
})(UserPreferenceEventActions = exports.UserPreferenceEventActions || (exports.UserPreferenceEventActions = {}));
var AddToGroupPosition;
(function (AddToGroupPosition) {
    AddToGroupPosition["Top"] = "TOP";
    AddToGroupPosition["Botton"] = "BOTTOM";
})(AddToGroupPosition = exports.AddToGroupPosition || (exports.AddToGroupPosition = {}));
